import App from './components/App';

// console.clear();

console.log(
  `%cMy Microgap.\nA website from VICE`,
  'padding: 24px 0; color: #1a1a1a; font-size: 12px; font-family: Helvetica, sans-serif; font-weight: 700; line-height: 1.4em;'
);

document.addEventListener("DOMContentLoaded", function(event) {
  const app = new App();
});